import { apiGet, apiPost } from '../../../shared/api-client/index.js';

export interface TaskProposalForm {
  actionDraftId: string;
  revisionId: string;
  draftVersion: number;
  revisionStatus: string;
  draftStatus: string;
  approvalId: string | null;
  approvalStatus: string | null;
  editable: boolean;
  operation: 'create' | 'update';
  fields: {
    title: string;
    description: string | null;
    dueAt: string | null;
    priority: 'low' | 'medium' | 'high' | 'urgent';
    assigneeMemberId: string | null;
  };
}

export interface TaskProposalFormChange {
  expectedDraftVersion: number;
  expectedRevisionId: string;
  title?: string;
  description?: string | null;
  dueAt?: string | null;
  priority?: 'low' | 'medium' | 'high' | 'urgent';
  assigneeMemberId?: string | null;
}

export function getTaskProposalForm(approvalId: string) {
  return apiGet<TaskProposalForm>(`/task-proposals/approvals/${encodeURIComponent(approvalId)}`);
}

export function reviseTaskProposalForm(approvalId: string, change: TaskProposalFormChange) {
  return apiPost<TaskProposalForm, TaskProposalFormChange>(
    `/task-proposals/approvals/${encodeURIComponent(approvalId)}/revisions`,
    change,
  );
}
